import React from 'react';
import { Rocket, GraduationCap, Clock } from 'lucide-react';

interface LearningPreferencesFormProps {
  preferences: {
    level: string;
    goal: string;
    timeCommitment: string;
  };
  onUpdate: (field: string, value: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

export function LearningPreferencesForm({ preferences, onUpdate, onSubmit, isLoading }: LearningPreferencesFormProps) {
  return (
    <div className="space-y-6">
      <div>
        <label className="flex items-center gap-2 text-gray-700 font-medium mb-2">
          <GraduationCap className="w-4 h-4" />
          Experience Level
        </label>
        <select
          value={preferences.level}
          onChange={(e) => onUpdate('level', e.target.value)}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent bg-white"
        >
          <option value="Beginner">Beginner</option>
          <option value="Beginner-Intermediate">Beginner-Intermediate</option>
          <option value="Intermediate">Intermediate</option>
          <option value="Intermediate-Advanced">Intermediate-Advanced</option>
          <option value="Advanced">Advanced</option>
          <option value="Expert">Expert</option>
        </select>
      </div>

      <div>
        <label className="flex items-center gap-2 text-gray-700 font-medium mb-2">
          <Rocket className="w-4 h-4" />
          Learning Goal
        </label>
        <textarea
          value={preferences.goal}
          onChange={(e) => onUpdate('goal', e.target.value)}
          placeholder="What do you want to achieve by learning this subject?"
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent bg-white resize-none h-24"
        />
      </div>

      <div>
        <label className="flex items-center gap-2 text-gray-700 font-medium mb-2">
          <Clock className="w-4 h-4" />
          Time Commitment
        </label>
        <select
          value={preferences.timeCommitment}
          onChange={(e) => onUpdate('timeCommitment', e.target.value)}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent bg-white"
        >
          <option value="1-2 hours">1-2 hours per week</option>
          <option value="2-5 hours">2-5 hours per week</option>
          <option value="5-10 hours">5-10 hours per week</option>
          <option value="10+ hours">10+ hours per week</option>
        </select>
      </div>

      <div className="pt-6">
        <button
          onClick={onSubmit}
          disabled={!preferences.goal.trim() || isLoading}
          className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-lg hover:from-blue-700 hover:to-blue-600 disabled:opacity-50 disabled:hover:from-blue-600 disabled:hover:to-blue-500 transition-all duration-200 flex items-center justify-center gap-2 shadow-md"
        >
          {isLoading ? (
            <>
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Generating Roadmap...</span>
            </>
          ) : (
            <>
              <span>Generate Learning Roadmap</span>
              <Rocket className="w-5 h-5" />
            </>
          )}
        </button>
      </div>
    </div>
  );
}